export default __webpack_public_path__ + "static/media/layer1.0a74a2f7.png";